export const googleMapsApiKey = 'AIzaSyDk72ETfbwNUPjlCH0JXBfDGCBWuJNLAbg';

export default googleMapsApiKey;
